module.exports = __webpack_public_path__ + "static/media/SourceHanSerifCN-Medium.46fb2461.svg";